import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_generic_doc_custom_processing_filter_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  company_guid: fromDatatype.GuidDataFieldInterface;
  tenant_code: fromDatatype.VarcharDatatypeInterface;
  filter_code: fromDatatype.VarcharDatatypeInterface;
  gendoc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  gendoc_hdr_posting_status: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
}

export class bl_fi_generic_doc_custom_processing_filter_RowClass implements bl_fi_generic_doc_custom_processing_filter_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  company_guid: fromDatatype.GuidDataFieldInterface;
  tenant_code: fromDatatype.VarcharDatatypeInterface;
  filter_code: fromDatatype.VarcharDatatypeInterface;
  gendoc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  gendoc_hdr_posting_status: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
}